// extracted by mini-css-extract-plugin
module.exports = {"readTime":"ReadTime_readTime__w_Dzs"};